<app-dashboard-option [categories]="['CELL']" [label]="'REMOVE'">
  <div app-dashboard-option-content>
   <button mdbBtn (click)="onRemove()" type="button" color="danger" size="sm" class="px-2 z-depth-0 m-0" mdbWavesEffect>
      <i class="fas fa-trash fa-fw"></i>
    </button>
  </div>
</app-dashboard-option>